<template>
  <BaseButton
    text
    color="white"
    :class="isIconDisabled ? 'disabled disabled-icon' : ''"
    retain-focus-on-click
    :ripple="false"
    @click="copyBlogQuoteHandler()"
  >
    <BaseSpriteIcon icon-name="ico-content-blog-qoute"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{
      $t('Context.short.blogQuote')
    }}</span>
  </BaseButton>
</template>

<script>
import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('BlogQuoteControl.vue');

import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import Locator from '@shared/publication/locator.mjs';
import AppConstantsUtil from '@/services/utils/AppConstantsUtil';

export default {
  name: 'BlogQuoteControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    isDisabled() {
      const isAudioInSelection = Boolean(this.firstVoicesParaId);
      if (!isAudioInSelection) {
        return !this.isValidParaRange;
      }
      const currentParaAlignment = this.$store.getters[
        'PublicationStore/getParagraphAlignment'
      ](this.bookId, this.paraId);
      return (
        (currentParaAlignment || []).length === 0 || !this.isValidParaRange
      );
    },
    selectedParaIds() {
      const startParaId = this.selectedLocator?.startLocator
        ?.prefixedParagraphId;
      const endParaId = this.selectedLocator?.endLocator?.prefixedParagraphId;
      const paraIds = this.$store.getters[
        'PublicationStore/getParaIdFromStartToEnd'
      ](startParaId, endParaId);
      return paraIds;
    },
    isValidParaRange() {
      return (
        this.selectedParaIds.length > 0 &&
        this.selectedParaIds.length <=
          AppConstantsUtil.MAX_SELECTION_PARAS_NUMBER
      );
    },
    paraId() {
      return this.selectedLocator?.startLocator?.prefixedParagraphId;
    },
    firstVoicesParaId() {
      return this.selectedParaIds.find(paraId => {
        return this.$store.getters['PublicationStore/isElementVoiced'](
          this.bookId,
          paraId
        );
      });
    },
    isIconDisabled() {
      return this.$attrs['icon-disabled'];
    }
  },
  async mounted() {
    try {
      if (!this.firstVoicesParaId) {
        return;
      }
      await this.$store.dispatch('PlaybackStore/preloadAlignment', {
        bookId: this.bookId,
        paraId: this.firstVoicesParaId,
        preloadCount: this.selectedParaIds.length
      });
    } catch (error) {
      this.$_errorHandler(error);
    }
  },
  methods: {
    async copyBlogQuoteHandler() {
      try {
        if (this.isIconDisabled) {
          this.$store.dispatch('ManagePopupStore/openToaster', {
            text: this.$t('BlogQuoteControl.toaster.disabled.message', {
              paraNum: AppConstantsUtil.MAX_SELECTION_PARAS_NUMBER
            }),
            toasterClose: false
          });
          return;
        }
        const copyRange = Locator.deserialize(this.selectedLocator.toJSON());
        if (copyRange) {
          this.$store.dispatch('TextCopyStore/copyBlogQuote', {
            locator: copyRange,
            bookId: this.bookId
          });
        }

        this.$store.dispatch('ManagePopupStore/openSuccessToaster', {
          text: this.$t('BlogQuote.toaster.message')
        });
      } catch (error) {
        this.$_errorHandler(error);
      }
    },
    $_errorHandler(error) {
      logger.error(`get error on copy to blog error: ${error}`);

      const text = this.$t('PresentPublication.error.contextMenu');
      this.$store.dispatch('ManagePopupStore/openErrorToaster', { text });
    }
  }
};
</script>
